import { buildGenericPropertyComponent } from '../components/GenericPropertyComponent';
import { PropertySchema } from '../PropertySchema';

export interface DoubleConfiguration {
  max?: 0;
  min?: 0;
}

export const DoubleProperty = new PropertySchema<number, DoubleConfiguration>('double', {
  component: buildGenericPropertyComponent({
    inputProps: {
      // TODO: decide how to handle
      // type: 'number',
    },

    parseValue(value: string): number {
      const parsedValue = parseFloat(value);

      if (Number.isNaN(parsedValue)) {
        return 0;
      }

      return parsedValue;
    },

    formatValue(value: number): string {
      // TODO: limit precision?
      return value.toString();
    },
  }),
});
